import React, { ReactNode, useState, useEffect } from "react";
import { useAppContext } from "../context/AppContext";
import { Navigate } from "react-router-dom";
import authService from "../services/authService";

interface RequireAuthRouteProps {
  children: ReactNode;
}

const RequireAuthRoute: React.FC<RequireAuthRouteProps> = ({ children }) => {

  const { setSeller, sellerAccount, setSellerAccount, initialSessionChecked, setInitialSessionChecked } = useAppContext();

  useEffect(() => {
    if (!initialSessionChecked) {
      const checkSession = async () => {
        try {
          const response = await authService.getSessionProfile();
          if (response.sellerAccount && response.seller) {
            setSellerAccount(response.sellerAccount);
            setSeller(response.seller);
          }
          else {
            setSellerAccount(null);
            setSeller(null);
          }
        }
        catch (error) {
          setSellerAccount(null);
          setSeller(null);
        }
        finally {
          setInitialSessionChecked(true);
        }
      };
      checkSession();
    }
  }, [initialSessionChecked]);

  if (!initialSessionChecked) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border spinner-border-lg" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (sellerAccount == null) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;

}

export default RequireAuthRoute